












































































import { Component, Vue, Prop } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import SvcCatatanPemberianObat from "@/services/CatatanPemberianObat";

@Component({
  components: {}
})
export default class CpoRekapModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() err!: object;
  @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() dataRekap!: [];

  mounted() {}

  get pasien() {
    return storePasien.identitasPasien;
  }

  get headers() {
    return [
      { text: "No", value: "index", width: "35px" },
      { text: "Nama Obat", value: "nama", width: "150px" },
      { text: "Jumlah Obat", value: "qty", width: "50px", align: "center" },
      { text: "Jumlah Retur", value: "retur", width: "50px", align: "center" },
      { text: "Satuan", value: "satuan", width: "50px", align: "center" },
      {
        text: "Jumlah Pemberian",
        value: "pemberian",
        width: "50px",
        align: "center"
      }
    ];
  }

  get storeUser() {
    return userModule.user;
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  close() {
    this.dialog = false;
  }

  cetak() {
    SvcCatatanPemberianObat.print(this.register);
  }
}
